/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import React, {Component} from 'react';
import {translate} from "../../../../../api/utils/i18nHelper";
import {connect} from "react-redux";
import {addBundleToCart} from "../../../../../actions/my-puratos/myProducts.action";
import RelatedProductRow from "./RelatedProductRow";
import {addBundleToCartAction, isLoadingById} from "../../../../../selectors/my-puratos/loader";
import {DesktopOnly, MobileOnly, Table} from "../../../atoms/table/Table";
import {AddToCartCell, CELL_SIZE, QuantityInputCell, UnitPriceValueCell} from "../../../atoms/table/Cells";
import {selectBundleOption} from "../../../../../selectors/my-puratos/cart";
import {RoleMatrix} from "../../../../../utils/my-puratos/roleUtils";
import {WithRole} from "../../../hoc/withRole";
import {TextColors} from "../../../../../config/styles";
import {ToggleIcon} from "../../../../atoms/bootstrap/Icons";
import {ShowHide} from "../../../electrons/ShowHide";
import {GTMContext} from "../../../../../analytics/ga4/utils/GTMContext";


class BundleRow extends Component {

    static contextType = GTMContext;

    state = {
        quantity: 1,
        addedQuantity: 0,
        response: false,
        showDetails: true,
    };

    updateQuantity = ({item: {quantity}}) => this.setState({ quantity });

    handleBundleOrder = (bundleId) => {
        if (bundleId !== undefined) {
            this.setState({
                quantity: 1,
                response: true,
                addedQuantity: this.state.addedQuantity + this.state.quantity
            })
        }
    };

    orderBundle = (alerts) => this.setState({ response: false }, () => {
        this.props.addBundleToCart({
            bundleId: selectBundleOption(this.props.data).bundleId,
            bundle: selectBundleOption(this.props.data),
            quantity: this.state.quantity,
            type: this.context,
            alerts,
            callback: this.handleBundleOrder
        })
    });

    toggleBundleDetails = () => this.setState({showDetails: !this.state.showDetails});

    render() {
        const {data, i18n, isLoading, titleClickable, wide, showPrice} = this.props;
        const { response, showDetails } = this.state;

        const option = selectBundleOption(data);

        return (
            <>
                <Table.Row className={'p-bgcolor-faded-yellow'} noMobileMargin>
                    <Table.Cell valign={"center"} align={"left"} size={CELL_SIZE._equalLg} mobileFullWidth>
                        <h6 className={"p-margin-top-xs p-margin-bottom-xs"}>
                            <span className="my-puratos__bundle-title text-small-semi-bold">
                                {translate(i18n, "Bundle")}: {data.shortPromoText}
                            </span>
                        </h6>
                        <a className={"p-bundle-row__show-hide p-margin-bottom-xs"} onClick={this.toggleBundleDetails}>
                            {showDetails ? translate(i18n, "Collapse details") : translate(i18n, "Expand details")}
                            <span className={showDetails ? "open" : "closed"}/>
                        </a>
                    </Table.Cell>
                    <WithRole roles={[RoleMatrix.puratosCustomerValidated]}>
                        {showPrice && <>
                            <DesktopOnly>
                                <Table.Cell size={CELL_SIZE._equal}/>
                                <Table.Cell size={CELL_SIZE._equal}/>
                            </DesktopOnly>
                            <UnitPriceValueCell valign={"center"} align={"left"} size={CELL_SIZE._equal}
                                                product={option} i18n={i18n} mobileFullWidth isBundle/>
                        </>}
                        <DesktopOnly>
                            <QuantityInputCell valign={"center"} align={"center"} size={CELL_SIZE._120} i18n={i18n}
                                               product={this.state} modifiable minimumQuantity={1}
                                               maximumQuantity={option.remainingQuantity - this.state.addedQuantity}
                                               updateItem={this.updateQuantity} disableInput={isLoading}/>
                            <AddToCartCell valign={"center"} align={"right"} size={CELL_SIZE._75}
                                           response={response} loading={isLoading}
                                           handleClick={this.orderBundle}/>
                        </DesktopOnly>
                        <MobileOnly>
                            <QuantityInputCell valign={"center"} i18n={i18n} product={this.state} modifiable
                                               minimumQuantity={1} maximumQuantity={option.remainingQuantity - this.state.addedQuantity}
                                               updateItem={this.updateQuantity} disableInput={isLoading}/>
                            <AddToCartCell valign={"center"} response={response} loading={isLoading}
                                           handleClick={this.orderBundle}/>
                        </MobileOnly>
                    </WithRole>
                </Table.Row>
                <ShowHide show={showDetails}>
                {
                    option.items.map((item,i) => (
                        <React.Fragment key={i}>
                            <RelatedProductRow titleClickable={titleClickable} data={item} i18n={i18n}
                                               wide={wide} noTotal showPrice={showPrice}/>
                        </React.Fragment>))
                }
                </ShowHide>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    isLoading: isLoadingById(state, addBundleToCartAction(selectBundleOption(ownProps.data, {}).bundleId))
});

const mapDispatchToProps = {
    addBundleToCart
};

export default connect(mapStateToProps, mapDispatchToProps)(BundleRow);
